// Hide developer logs in the production build (enable with localStorage.debug = '1')
if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined' && window.localStorage?.getItem('debug') !== '1') {
  ['log', 'info', 'debug', 'warn', 'error', 'table', 'group', 'groupCollapsed', 'groupEnd', 'trace'].forEach((m) => {
    console[m] = () => {};
  });
}
